module.exports = __webpack_public_path__ + "play-button-blue.png?e2d09dd0369c132a9a0ebca04e151670";


//////////////////
// WEBPACK FOOTER
// ./assets/img/play-button-blue.png
// module id = 8
// module chunks = 0